import React from "react";
import { Table, Card } from "antd";
import { buildMaterialsTable } from "../utils/materialMapping";

export const ExpandedOrderRow = ({ record, rawOrders, warehouseStock }) => {
    const rawOrder = rawOrders?.find((o) => o._id === record._id);
    const materials = buildMaterialsTable(rawOrder, warehouseStock);

    // Разделяем на группы
    const doorsGroup = materials.filter(m => m.group === "Материалы для дверей");
    const accsGroup = materials.filter(m => m.group === "Комплектующие");

    const dataSource = [];
    let counter = 1;

    if (doorsGroup.length > 0) {
        dataSource.push({ isHeader: true, label: "— Материалы для дверей —", _id: "hdr-doors" });
        doorsGroup.forEach(m => {
            m.num = counter++;
            dataSource.push(m);
        });
    }

    if (accsGroup.length > 0) {
        dataSource.push({ isHeader: true, label: "— Комплектующие —", _id: "hdr-accs" });
        accsGroup.forEach(m => {
            m.num = counter++;
            dataSource.push(m);
        });
    }

    const columns = [
        {
            title: "№",
            key: "num",
            dataIndex: "num",
            width: 45,
            align: "center",
            render: (val, record) => record.isHeader ? null : val,
        },
        {
            title: "Наименование",
            dataIndex: "label",
            key: "label",
            render: (val, record) => record.isHeader ? <strong>{val}</strong> : val,
        },
        {
            title: "Кол-во",
            dataIndex: "required",
            key: "quantity",
            width: 80,
            align: "center",
            render: (val, record) => record.isHeader ? null : val,
        },
        {
            title: "Ед. изм.",
            dataIndex: "unit",
            key: "unit",
            width: 80,
            align: "center",
            render: (val, record) => record.isHeader ? null : val,
        },
        {
            title: "Необходимо",
            dataIndex: "required",
            key: "required",
            width: 100,
            align: "center",
            render: (val, record) => record.isHeader ? null : <strong>{val}</strong>,
        },
        {
            title: "На складе",
            dataIndex: "inStock",
            key: "inStock",
            width: 180,
            render: (inStock, record) => {
                if (record.isHeader) return null;
                const required = record.required;
                if (inStock >= required) {
                    return <span style={{ color: "#52c41a", fontWeight: "bold" }}>{inStock} ✅</span>;
                } else if (inStock > 0 && inStock < required) {
                    return <span style={{ color: "#fa8c16", fontWeight: "bold" }}>{inStock} (не хватает {required - inStock}) ❌</span>;
                } else {
                    return <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>0 (не хватает {required}) ❌</span>;
                }
            }
        }
    ];

    return (
        <Card
            size="small"
            style={{ margin: "8px 0", border: "1px solid #e8f4ff", borderRadius: 6, backgroundColor: "#fafcff", overflow: "hidden" }}
            bodyStyle={{ padding: "0" }}
        >
            <Table
                size="small"
                bordered
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                locale={{ emptyText: "Нет данных о комплектующих" }}
                onRow={(record) => {
                    const diff = record.inStock - record.required;
                    let bg = "";
                    if (record.inStock === 0) bg = "#fff1f0"; // red background
                    else if (diff < 0) bg = "#fff7e6"; // orange background
                    
                    return {
                        style: { backgroundColor: bg }
                    };
                }}
            />
        </Card>
    );
};
